import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import RMSMD from "@/services/user.public.service.js";

export default new Vuex.Store({
  state: {
    numeroProductosCarrito: "0",
    haIniciadoSesion: false,
    muestraMensajeGlobal: false,
    elMensajeGlobal: "",
    laConfiguracionSuscriptor: {
      usaPedidosEnLinea: false,
    },
    elSuscriptor: {
      urlLogoSuscriptor: "",
    },
  },
  mutations: {
    //Guarda la información del suscriptor
    establecerSuscriptor(state, elSuscriptor) {
      state.elSuscriptor = elSuscriptor;
      sessionStorage.setItem("claveInstancia", elSuscriptor.claveSuscriptor);
      sessionStorage.setItem("elSuscriptor", JSON.stringify(elSuscriptor));
    },
    //Guarda la configuración del suscriptor
    establecerConfiguracionSuscriptor(state, laConfiguracion) {
      state.laConfiguracionSuscriptor = laConfiguracion;
      sessionStorage.setItem("laConfiguracion", JSON.stringify(laConfiguracion));
    },
    establecerNumeroProductos(state, cuantosHay) {
      state.numeroProductosCarrito = cuantosHay;
    },
    establecerHaIniciadoSesion(state, haIniciado) {
      state.haIniciadoSesion = haIniciado;
    },
    enviarMensajeGlobal(state, mensaje) {
      state.muestraMensajeGlobal = true;
      state.elMensajeGlobal = mensaje;
    },
  },
  actions: {
    getDatosSuscriptor(context, claveInstancia) {
      RMSMD.getDatosSuscriptor(claveInstancia)
        .then((response) => {
          console.log("ok leer al suscriptor en vuex");
          const elSus = response.data.suscriptor;
          const laConfigSus = response.data.configuracion;
          context.commit("establecerSuscriptor", elSus);
          context.commit("establecerConfiguracionSuscriptor", laConfigSus);
          if (claveInstancia.toUpperCase() == "B97F8476-1CA8-4BBC-8603-BC78CDF0B2B1") {
            sessionStorage.setItem("muestraLegales2", "1");
          }
          else {
            sessionStorage.setItem("muestraLegales2", "0");
          }
        })
        .catch((error) => {
          /* this.errored = true;
          if (error.response !== undefined) {
            if (error.response.data.mensajeError !== undefined)
              this.mensajeError = error.response.data.mensajeError[0];
            else this.mensajeError = error.response.estatusText;
          }
          //Usando un RMSException en el servidor
          else this.mensajeError = error; */
        })
        .finally(() => {
          //this.loading = false;
        });
    },
  },
  modules: {},
});
